export default "__VITE_ASSET__dabd57a3__"